import pedidoAtualizacaoCadastral from './pedidoAtualizacaoCadastral/config';
import pedidoAtualizacaoSubsecao from './pedidoAtualizacaoSubsecao/config';

export const pedido_atualizacao_cadastral = pedidoAtualizacaoCadastral;
export const pedido_atualizacao_subsecao = pedidoAtualizacaoSubsecao;
